import { render, staticRenderFns } from "./dashscreen.vue?vue&type=template&id=300cb210"
import script from "./dashscreen.ts?vue&type=script&lang=js&external"
export * from "./dashscreen.ts?vue&type=script&lang=js&external"
import style0 from "./dashscreen.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports